
import { FlaskConical, Target, RefreshCw, CheckSquare } from 'lucide-react';

const WhatIsPACTSection = () => {
  return (
    <section id="what-is-pact" className="container max-w-6xl mx-auto px-4 py-24">
      <div className="text-center mb-16">
        <h2 className="text-5xl md:text-6xl font-black text-white mb-6 tracking-tight">
          What is a
          <span className="block text-yellow-400">PACT?</span>
        </h2>
        <p className="text-xl md:text-2xl text-white/90 mb-8 font-bold max-w-4xl mx-auto">
          The building block that comes before habits
        </p>
        <p className="text-lg text-white/80 max-w-3xl mx-auto font-medium leading-relaxed">
          A PACT is a simple commitment: <span className="text-yellow-400 font-bold">"I will [action] for [duration]."</span> 
          <br />No forever pressure. No guilt when it ends. Just show up, learn, and decide what's next.
        </p>
      </div>

      {/* PACT Framework Visual */}
      <div className="bg-white/10 backdrop-blur-lg rounded-[3rem] p-12 border border-white/20 shadow-2xl">
        <h3 className="text-4xl font-black text-white text-center mb-12">The PACT Framework</h3>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* P - Purposeful */}
          <div className="text-center group">
            <div className="w-20 h-20 bg-yellow-400/20 backdrop-blur-sm rounded-3xl flex items-center justify-center mx-auto mb-6 group-hover:bg-yellow-400/30 transition-all duration-300 border border-yellow-400/30">
              <Target className="w-10 h-10 text-yellow-400" />
            </div>
            <div className="bg-yellow-400/10 rounded-2xl p-6 border border-yellow-400/20">
              <h4 className="text-3xl font-black text-yellow-400 mb-3">P</h4>
              <h5 className="text-xl font-bold text-white mb-3">Purposeful</h5>
              <p className="text-white/80 leading-relaxed font-medium">
                Feels exciting and meaningful for your learning journey
              </p>
            </div>
          </div>

          {/* A - Actionable */}
          <div className="text-center group">
            <div className="w-20 h-20 bg-white/15 backdrop-blur-sm rounded-3xl flex items-center justify-center mx-auto mb-6 group-hover:bg-white/25 transition-all duration-300 border border-white/20">
              <FlaskConical className="w-10 h-10 text-white" />
            </div>
            <div className="bg-white/10 rounded-2xl p-6 border border-white/20">
              <h4 className="text-3xl font-black text-white mb-3">A</h4>
              <h5 className="text-xl font-bold text-white mb-3">Actionable</h5>
              <p className="text-white/80 leading-relaxed font-medium">
                Doable with your current resources, start today
              </p>
            </div>
          </div>

          {/* C - Continuous */}
          <div className="text-center group">
            <div className="w-20 h-20 bg-purple-300/20 backdrop-blur-sm rounded-3xl flex items-center justify-center mx-auto mb-6 group-hover:bg-purple-300/30 transition-all duration-300 border border-purple-300/30">
              <RefreshCw className="w-10 h-10 text-purple-300" />
            </div>
            <div className="bg-purple-300/10 rounded-2xl p-6 border border-purple-300/20">
              <h4 className="text-3xl font-black text-purple-300 mb-3">C</h4>
              <h5 className="text-xl font-bold text-white mb-3">Continuous</h5>
              <p className="text-white/80 leading-relaxed font-medium">
                Simple and repeatable (daily, weekly, etc.)
              </p>
            </div>
          </div>

          {/* T - Trackable */}
          <div className="text-center group">
            <div className="w-20 h-20 bg-green-400/20 backdrop-blur-sm rounded-3xl flex items-center justify-center mx-auto mb-6 group-hover:bg-green-400/30 transition-all duration-300 border border-green-400/30">
              <CheckSquare className="w-10 h-10 text-green-400" />
            </div>
            <div className="bg-green-400/10 rounded-2xl p-6 border border-green-400/20">
              <h4 className="text-3xl font-black text-green-400 mb-3">T</h4>
              <h5 className="text-xl font-bold text-white mb-3">Trackable</h5>
              <p className="text-white/80 leading-relaxed font-medium">
                Binary tracking - Did you do it? Yes or No.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatIsPACTSection;
